import React from 'react';

export function Throw() {
    if (PRODUCTION) {
        throw new Error('This is a test error');
    }
    return <div>Throw</div>;
}
